import { isObject, isString } from './type';
// import Vue from 'vue';
import RavenJS from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import { elk,itil,acc } from './report';
import { getUin } from './user';
import { getIsEnvProduction, getEnvConfig } from './libs/env';
import { checkReport, alarm } from './alarm';

export function formatError(obj) {
    const errObj = { type: 'custom', msg: '', payload: {} };
    if (isString(obj)) {
        errObj.msg = obj;
    } else if (isObject(obj)) {
        Object.assign(errObj, obj);
    }
    return errObj;
}

export function checkCustomError(err) {
    if (isObject(err) && err.type === 'custom') return true;
    return true;
}

export function checkSystemError(err) {
    return err instanceof Error;
}

let businessName = "";

/**
 * 初始化全局错误上报
 */
export function initGlobalErrorReport(option, Vue){
    const { sentry , business , appEnv } = option;
    const isEnvProduction = getIsEnvProduction()// 是否是正式环境
    if(business){
        businessName = business;
    }
    //接入sentry
    Raven
    .config(sentry.dsn, {
      //展示sentry上报的log，这个log太弱了，容易被被忽视
      debug:true,
      //A callback function that allows you to apply your own filters to determine if the message should be sent to Sentry.
      shouldSendCallback: function(data) {
          const exceptionInfo = data.exception ? data.exception.values[0] : null;
          let shouldSend = false;
          
          if(exceptionInfo){
            //如果是逻辑异常比如接口请求失败导致的CustomException，不是JsError，不要上报sentry
            const isLogicException = exceptionInfo.value && /Non-Error exception captured/.test(exceptionInfo.value) ? true : false;
            //捕获:throw
            //如果是js-error的，错误，就上报sentry
            if(!isLogicException && /^(Error|EvalError|RangeError|ReferenceError|SyntaxError|TypeError|URIError)$/.test(exceptionInfo.type)){
              shouldSend = true;
              const reportError = data.exception.values.length === 1 ? data.exception.values[0] : data.exception.values;
              //sentry上报的log，这个log太弱了，容易被忽视，所以重点标记一下
              console.error('%c%s', 'color: white; background: red; font-size: 12px; padding: 2px;', `[ Sentry Caught Error ] ${reportError.type} : ${reportError.value}\n`, reportError);
            }else{
              //如果是customExceptoin,就不上报sentry
              shouldSend = false;
            }
          }else{
            //这种一般是捕获:unhandledrejection
            shouldSend = true;
          }

          if(shouldSend){
            //sentry的错误也上报elk，elk好做视图。elk视图，有区分开发环境，测试环境，就都上报了
            elk({
              key: exceptionInfo ? exceptionInfo.type : 'unhandledrejection',
              str1: 'sentry_error_report'
            });
          }

          if(appEnv !== 'production'){
            //如果是来自非生产环境，就不上报elk
            // 此变量为编译环境变量 触发此逻辑一般为本地开发
            shouldSend = false;
          } else if(!isEnvProduction){
            // 此变量为运行时变量 区别当前环境是否是idc环境
            console.info('当前环境为非idc环境',getEnvConfig());
            shouldSend = false;
          }

          return shouldSend;
      },
      ...sentry,
    })
    .addPlugin(RavenVue, Vue)
    .install();

    Raven.setTagsContext({  uin: getUin() });
}

const reportedMap = {};
/**
 * 需要上报的业务异常基础类
 * 业务需要自己继承该异常，重写business
 *  class BaseException extends CustomException{
        constructor(err, name, message, option = { noReportElk: false, business: 'Scanpay' }) {
            super(err, name, message, option);
        }
    }
 */
export class CustomException /*extends Error */{
  //message为代码中的关键字，后续可以搜索到代码对应的逻辑
  constructor(err, name, message, option = { noReportElk: false, business: businessName, itilId: '', reportOnce: false, noReportAcc: false, alarmCfg: {} }) {
    //super();
    option = option || {};
    const { noReportElk, business, reportOnce, itilId, noReportAcc, alarmCfg = {} } = option;
    this.business = business;
    //name作为自定义异常的key,用户搜索
    this.name = name || 'BaseException';
    //自定义异常，更多的附加信息
    this.message = message || 'default Message';
    //当有系统报出的错误，是有stack的，就用系统报错的stack。如果没有，那可能是来自某个reject,那这个就用当前的堆栈
    this.stack = err && err.stack ? err.stack : '';

    //err有可能是string,也可能是error对象，也可能是http请求的reject。
    //当如果是http请求的reject，可能外层处理，需要用到data，比如密码校验失败，展示弹窗时候，需要这里很多数据
    //这里是为了能够把reject的数据，携带出去，携带到最上层的自定义错误
    const data = err && err.data ? err.data : err;
    if (!(data instanceof Error) && typeof data === 'object') {
      this.data = data;
    } else {
      //有些地方直接reject一个string,又不是JsError，这种情况也需要记录下来
      if(typeof data === 'string'){
        this.data = { defaultMsg: data };
      }else{
        this.data = null;
      }
    }
    //当是系统爆出的badjs异常，就上报sentry,
    if (
      err &&
      err.stack &&
      /^(Error|EvalError|RangeError|ReferenceError|SyntaxError|TypeError|URIError):(.*)?\n/.test(
        err.stack
      ) &&
      !err.hasReportToSentry
    ) {
      this.reportSentry(err);
      this.hasReportToSentry = true;
    }
    if(itilId){
      itil(itilId);
    }
    //如果错误只上报一次，且已经上报过，就不上报elk了
    if(reportOnce && reportedMap[this.name]){
      return;
    }
    //上报elk
    if(!noReportElk){
      this.reportElk(business);
    }
    //上报acc
    if(!noReportAcc){
      this.reportAcc(alarmCfg);
    }
  }

  /**
   * 获取数据
   * @return {[type]} [description]
   */
  getData() {
    return this.data;
  }

  /**
   * 控制台输出错误
   * @return {[type]} [description]
   */
  logError() {
    //这里做一次log,log除了badjs之外的异常。badjs的异常，是sentry那边shouldSendCallback上报了
    console.error(
      '%c%s',
      'color: white; background: red; font-size: 12px; padding: 2px;',
      `[ ${this.name} ] ${this.message}\n`,
      'stack:\n',
      this.stack,
      '\ndata:\n',
      this.data
    );
  }

  /**
   * 上报到sentry
   */
  reportSentry(err) {
    Raven.captureException(err);
  }

  /**
   * 上报elk
   * @return {[type]} [description]
   */
  reportElk(options) {
    reportedMap[this.name] = true;
    //上报前，log一下
    this.logError();
    const defaultOptions = {
      key: this.name,
      msg: this.message,
      str1: `CustomException`, //后续通过这个字段来做视图
      str4: JSON.stringify(this.data), //记录http错误，接口的返回，或者jsapi调用错误的返回
      str5: this.stack ? this.stack.substr(0, this.stack.indexOf('\n')) : '' //记录stack,只记录一行
    };
    const param = Object.assign({}, defaultOptions, options);
    elk(param);
  }

  reportAcc(alarmCfg) {
    alarmCfg = alarmCfg || {};
    if (alarmCfg.reportClose === false || checkReport()) {
      alarm(Object.assign({
        name: this.name,
        message: this.message,
        err: this.data
      }, alarmCfg));
    } else {
      // 业务异常同时上报acc，可以用于做告警
      acc({
        /* service */
        service: this.name,
        ext1: 'CustomException',
        respack: this.message
      });    
    }
  }
}

export const Raven = RavenJS;